

















import { useCarousel } from '@/uikit/components/AppDefaultLayout/components/parts/slider/carousel';

export default {
  name: "ContentSlider",
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      carousel: {} as ReturnType<typeof useCarousel>,
      sliderWidth: 720,
      handler: null,
      interval: null,
      intervalHandler: null,
    }
  },
  computed: {
    cSliderWidth() {
      return this.sliderWidth
    },
    currentSlide() {
      return this.carousel?.data?.currentSlide?.index || 0;
    }
  },
  mounted() {
    this.updateSliderWidth();
    this.carousel = useCarousel({
      wrapElem: this.$refs.carouselWrapper,
      isLoop: true
    });
    this.updateSliderWidth();
    this.setSlideWidth();
    this.handler = () => {
      this.updateSliderWidth();
      this.setSlideWidth();
    }
    this.intervalHandler = () => {
      this.carousel.navigate.nextSlide();
    }
    window.addEventListener('resize', this.handler);
    this.interval = setInterval(this.intervalHandler, 4000);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handler);
    this.handler = null;
    clearInterval(this.interval);
    this.interval = null;

  },
  methods: {
    updateSliderWidth() {
      this.sliderWidth = this.$refs.carouselWrapper?.getBoundingClientRect()?.width || 0
    },
    setSlideWidth() {
      this.$refs.sliderSlide.forEach((el: HTMLElement) => {
        el.style.width = `${this.cSliderWidth}px`;
      })
    }
  }
}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppDefaultLayout/components/sections/signboardNew/ContentSlider.vue